import { getChannelAPIPath } from '@treasury/core/http';

MessagingCenterService.$inject = ['$resource'];

export default function MessagingCenterService($resource) {
    return {
        get,
        getMessageCategories,
        save,
        saveMessage,
        getMessageThread,
        search,
        silentSearch,
        update,
        downloadAttachment,
    };

    function get() {
        return $resource(
            `${getChannelAPIPath()}messagingcenter/`,
            {},
            { get: { method: 'GET', isArray: false } }
        ).get().$promise;
    }

    function save(model) {
        return $resource(`${getChannelAPIPath()}messagingcenter/`).save(model).$promise;
    }

    function getMessageCategories() {
        return $resource(`${getChannelAPIPath()}messagingcenter/getMessageCategories`).query()
            .$promise;
    }

    function saveMessage(message) {
        return $resource(
            `${getChannelAPIPath()}messagingcenter/savemessage`,
            {},
            {
                save: {
                    method: 'POST',
                    transformRequest: transformMessage,
                    headers: { 'Content-Type': undefined, enctype: 'multipart/form-data' },
                },
            }
        ).save(message).$promise;
    }

    function transformMessage(message) {
        const fd = new FormData();
        fd.append('CompanyId', message.companyId);
        fd.append('UserId', message.userId);
        fd.append('CategoryId', message.categoryId);
        fd.append('Body', message.body);
        fd.append('ParentMessageId', message.parentMessageId);
        fd.append('AssignedToUserId', message.assignedToUserId);
        console.log(message.files);
        angular.forEach(message.files, file => {
            fd.append('file', file.rawFile);
        });
        return fd;
    }

    function getMessageThread(id) {
        return $resource(`${getChannelAPIPath()}messagingcenter/messagethread/:id`, { id }).query()
            .$promise;
    }

    function search(searchTerms) {
        return $resource(
            `${getChannelAPIPath()}messagingcenter/search`,
            {},
            { search: { method: 'post', isArray: true } }
        ).search(searchTerms).$promise;
    }

    function silentSearch(searchTerms) {
        return $resource(
            `${getChannelAPIPath()}messagingcenter/search?silent=1`,
            {},
            { search: { method: 'post', isArray: true } }
        ).search(searchTerms).$promise;
    }

    function update(updateObject) {
        return $resource(`${getChannelAPIPath()}messagingcenter/update`).save(updateObject)
            .$promise;
    }

    function downloadAttachment(id, oldAttachment = false) {
        let endpointUrl = `${getChannelAPIPath()}file`;
        if (oldAttachment) {
            endpointUrl = `${getChannelAPIPath()}messagingcenter/downloadattachment`;
        }
        return $resource(
            `${endpointUrl}/:id`,
            { id },
            {
                download: {
                    method: 'get',
                    responseType: 'arraybuffer',
                    transformResponse(data, headersGetter) {
                        return { data };
                    },
                },
            }
        ).download().$promise;
    }
}
